import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SentryPerformanceService } from './sentry-performance.service';

export type NetworkStatus = 'online' | 'offline' | 'poor';

@Injectable({ providedIn: 'root' })
export class ConnectivityService {
  private status = new BehaviorSubject<NetworkStatus>('online');
  public status$ = this.status.asObservable();

  constructor(private ngZone: NgZone, private sentryPerf: SentryPerformanceService) {
    window.addEventListener('online', () =>
      this.ngZone.run(() => this.updateStatus('online'))
    );
    window.addEventListener('offline', () =>
      this.ngZone.run(() => this.updateStatus('offline'))
    );

    const connection = (navigator as any).connection;
    if (connection) {
      connection.addEventListener('change', () => {
        this.ngZone.run(() => {
          if (!navigator.onLine) {
            this.updateStatus('offline');
          } else if (connection.downlink < 1 || connection.effectiveType.includes('2g')) {
            this.updateStatus('poor', connection.downlink, connection.effectiveType);
          } else {
            this.updateStatus('online', connection.downlink, connection.effectiveType);
          }
        });
      });
    }
  }

  private updateStatus(status: NetworkStatus, downlink?: number, effectiveType?: string) {
    this.status.next(status);
    this.sentryPerf.trackNetworkChange(status, downlink, effectiveType);
  }
}